<template>
  <div
    v-show="showOverlay"
    class="absolute z-20 flex h-full w-full items-start justify-center rounded-lg bg-black/[.4] pt-56 lg:items-center lg:pt-0"
    data-testid="subscription-overlay"
  >
    <div class="flex flex-col items-center gap-3 rounded-lg bg-white p-6">
      <h4 class="text-base font-semibold">Subscribe to gain access</h4>
      <CommonButtonContactUs @click="onClick" />
      <div
        class="flex max-w-content-container items-center justify-center text-xs"
      >
        Already a subscriber?
        <button
          class="ml-2 cursor-pointer font-bold text-p-300"
          @click="$modal.open('signIn')"
        >
          {{ signInText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import CommonButtonContactUs from '~/components/shared/common/ButtonContactUs.vue'
import { SIGN_IN } from '~/constants/services/constants'

withDefaults(
  defineProps<{
    showOverlay?: boolean
  }>(),
  {
    showOverlay: false,
  },
)

const signInText = ref(SIGN_IN)
const { $modal, $rudderstack } = useNuxtApp()

const onClick = () => {
  $rudderstack.trackContentGatedInteraction()
}
</script>
